import React from 'react';
import Icon from './Icon';
import { ICONS } from '../../constants/enums';
import i18n from '../../i18n/config';

const PrintPage = () => {
  const handleClick = () => {
    window.print();
  }
  return (
    <button className="flex-row btn btn-text" onClick={handleClick}>
      <Icon icon={ICONS.PRINT} className="icon-left" />
      <p className="text-blue-700 spacing-bottom-none">{i18n.t("COMPONENTS.PRINT_PAGE.TEXT")}</p>
    </button>
  );
}

export default PrintPage;